export enum CertificateType {
  AhaBasicLifeSupport = 'AhaBasicLifeSupport',
  AhaAdvancedCardiovascularLifeSupport = 'AhaAdvancedCardiovascularLifeSupport',
  AhaNeonatalAdvancedLifeSupport = 'AhaNeonatalAdvancedLifeSupport',
  AhaPediatricAdvancedLifeSupport = 'AhaPediatricAdvancedLifeSupport',
  AhaAdvancedStrokeLifeSupport = 'AhaAdvancedStrokeLifeSupport',
  AhaPears = 'AhaPears',
  AhaHeartsaver = 'AhaHeartsaver'
}

export const MapCertificateTypeWithLabel: ObjectType<string> = {
  [CertificateType.AhaBasicLifeSupport]: '(AHA) Basic Life Support',
  [CertificateType.AhaAdvancedCardiovascularLifeSupport]: '(AHA) Advanced Cardiovascular Life Support',
  [CertificateType.AhaNeonatalAdvancedLifeSupport]: '(AHA) Neonatal Advanced Life Support',
  [CertificateType.AhaPediatricAdvancedLifeSupport]: '(AHA) Pediatric Advanced Life Support',
  [CertificateType.AhaAdvancedStrokeLifeSupport]: '(AHA) Advanced Stroke Life Support',
  [CertificateType.AhaPears]: '(AHA) Pediatric Emergency Assessment, Recognition, and Stabilization (PEARS)',
  [CertificateType.AhaHeartsaver]: '(AHA) Heartsaver'
};
